import { Drawer, Tag, Descriptions, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useGetSingleOperator } from './Hooks';

const { useBreakpoint } = Grid;

export default function ViewOperatorDrawer({ isOpen, operatorId, onClose }) {
  const { t } = useTranslation('operator');
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  // Fetch operator details
  const { data: operator, isLoading: isLoadingOperator } = useGetSingleOperator({
    id: operatorId,
    options: {
      enabled: !!operatorId && isOpen,
    },
  });

  return (
    <Drawer
      title={t('viewOperator')}
      placement="right"
      onClose={onClose}
      open={isOpen}
      width={isMobile ? '100%' : 600}
      className="md:w-[600px] min-w-full"
      loading={isLoadingOperator}
    >
      {operator ? (
        <Descriptions
          bordered
          size="small"
          layout="vertical"
          column={{ xxl: 3, xl: 3, lg: 3, md: 2, sm: 1, xs: 1 }}
          labelStyle={{ fontWeight: 600, whiteSpace: 'nowrap' }}
          contentStyle={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            wordWrap: 'break-word',
            overflowWrap: 'break-word'
          }}
        >
          <Descriptions.Item label={t('name')}>
            {operator.name}
          </Descriptions.Item>
          <Descriptions.Item label={t('owner')}>
            {operator.contactPersonFname} {operator.contactPersonLname}
          </Descriptions.Item>
          <Descriptions.Item label={t('email')}>
            {operator.contactPersonEmailAddress || '-'}
          </Descriptions.Item>

          <Descriptions.Item label={t('phoneNumber')}>
            {operator.contactPersonPhoneNumber
              ? `+${operator.countryCode || ''} ${operator.contactPersonPhoneNumber}`.trim()
              : '-'}
          </Descriptions.Item>

          <Descriptions.Item label={t('address')} span={3}>
            {operator.address || '-'}
          </Descriptions.Item>

          <Descriptions.Item label={t('status')}>
            <Tag color={operator.status === 'BLOCKED' ? 'red' : 'green'} variant="outlined">
              {t(operator.status)}
            </Tag>
          </Descriptions.Item>

          <Descriptions.Item label={t('locations')}>
            {operator.locationCount != null ? operator.locationCount : '-'}
          </Descriptions.Item>
          <Descriptions.Item label={t('totalChargers')}>
            {operator.serialNumberCount != null ? operator.serialNumberCount : '-'}
          </Descriptions.Item>
          <Descriptions.Item label={t('createdAt')}>
            {operator.created_at
              ? new Date(operator.created_at * 1000).toLocaleString()
              : '-'}
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <p>{t('noData')}</p>
      )}
    </Drawer>
  );
}

ViewOperatorDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  operatorId: PropTypes.string,
};
